import advilia0 from "../assets/images/projects/advilia/advilia0.png";
import advilia1 from "../assets/images/projects/advilia/advilia1.png";
import advilia2 from "../assets/images/projects/advilia/advilia2.png";
import cohabit0 from "../assets/images/projects/cohabit/cohabit0.png";
import cohabit1 from "../assets/images/projects/cohabit/cohabit1.png";
import cohabit2 from "../assets/images/projects/cohabit/cohabit2.png";
import logbotai0 from "../assets/images/projects/logbotai/logbotai0.png";
import logbotai1 from "../assets/images/projects/logbotai/logbotai1.png";
import logbotai2 from "../assets/images/projects/logbotai/logbotai2.png";
import promptStudio0 from "../assets/images/projects/promptstudio/promptstudio0.png";
import promptStudio1 from "../assets/images/projects/promptstudio/promptstudio1.png";
import promptStudio2 from "../assets/images/projects/promptstudio/promptstudio2.png";
import zschatbot0 from "../assets/images/projects/zschatbot/zschatbot0.png";
import zschatbot1 from "../assets/images/projects/zschatbot/zschatbot1.png";
import zschatbot2 from "../assets/images/projects/zschatbot/zschatbot2.png";

export type Project = {
  category: string;
  description: string;
  features: string[];
  id: string;
  images: string[];
  name: string;
  order: number;
  published: boolean;
  result: string;
  stack: string[];
  url: string;
};

export const localProjects: Project[] = [
  {
    category: "AI document assistant",
    description:
      "An AI-powered document analysis system that answers questions based on uploaded PDF and Word files.",
    features: [
      "Document-based Q&A",
      "Context-aware responses",
      "Cloud deployment and file processing",
    ],
    id: "logbotai",
    images: [logbotai0, logbotai1, logbotai2],
    name: "LogBotAI",
    order: 1,
    published: true,
    result:
      "A portfolio-defining AI product that demonstrates practical LLM usage, retrieval thinking, and full-stack delivery.",
    stack: ["JavaScript", "Node.js", "GCP", "GitHub"],
    url: "https://logbotai-380524912014.europe-west1.run.app/",
  },
  {
    category: "Business chatbot",
    description:
      "A custom AI-powered assistant built for Zello Systems to streamline access to company-specific information.",
    features: [
      "Company-specific answer flow",
      "Conversational support UI",
      "Hosted backend integration",
    ],
    id: "zs-chatbot",
    images: [zschatbot0, zschatbot1, zschatbot2],
    name: "ZS Chatbot",
    order: 2,
    published: true,
    result:
      "A focused assistant that supports operational efficiency with more relevant responses than a generic chatbot.",
    stack: ["JavaScript", "CSS", "Node.js", "Render"],
    url: "https://www.zellosystems.se/",
  },
  {
    category: "CMS website rebuild",
    description:
      "Enhancements to Prompt Studio's website, connecting Gatsby and Strapi for dynamic content management.",
    features: [
      "Strapi-managed content",
      "Gatsby frontend updates",
      "Reusable UI and styling improvements",
    ],
    id: "prompt-studio",
    images: [promptStudio0, promptStudio1, promptStudio2],
    name: "Prompt Studio",
    order: 3,
    published: true,
    result:
      "A more maintainable website workflow where content can be updated without manual code changes.",
    stack: ["TypeScript", "Gatsby", "Strapi", "Docker"],
    url: "https://prompt.studio/",
  },
  {
    category: "Client website",
    description:
      "A responsive website for Advilia Företagsmäklare and Advilia Redovisning that runs in a restricted hosting environment.",
    features: [
      "Responsive generated layout",
      "Scroll-triggered animation",
      "JSON-driven listings and cookie consent",
    ],
    id: "advilia",
    images: [advilia0, advilia1, advilia2],
    name: "Advilia",
    order: 4,
    published: true,
    result:
      "A lightweight client website that balances visual fidelity, maintainability, and strict hosting constraints.",
    stack: ["HTML", "CSS", "JavaScript", "JSON"],
    url: "https://advilia.se/",
  },
  {
    category: "Business system",
    description:
      "An order management system for Cohabit that automates customer and team email confirmations.",
    features: [
      "Order list builder",
      "Automated emails",
      "Confirmation and payment information flow",
    ],
    id: "booking-system-cohabit",
    images: [cohabit0, cohabit1, cohabit2],
    name: "Booking System - Cohabit",
    order: 5,
    published: true,
    result:
      "Reduced manual confirmation work and improved reliability for order handling during and after the internship.",
    stack: ["JavaScript", "CSS", "Node.js", "Email automation"],
    url: "https://orderwizard.cohabit.se/",
  },
];
